"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MortgageGuideRoutes", {
  enumerable: true,
  get: function () {
    return _MortgageGuideRoutes.default;
  }
});
var _MortgageGuideRoutes = _interopRequireDefault(require("./MortgageGuideRoutes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }